import Send from '../utils/Send.js'

export default {
    getTaxInvoice(data) {
        return Send({
            url: '/taxinvoice',
            method: 'post',
            data : data,
            headers : {'Content-Type': 'application/json'}
        })
    }
}